module.exports = new __parcel__URL__("multi_arrow.131b3c78.svg").toString();